import { usePartnerStore } from "../store/usePartnerStore";

/** Partner recovery attached to LINK_EXPIRED / LINK_REVOKED `error.details`. */
export type DeadLinkPartnerRecovery = {
  name?: string;
  sessionExpiredRedirectUrl?: string;
  supportEmail?: string;
  supportWhatsappNumber?: string;
};

export function partnerRecoveryFromErrorDetails(
  details: unknown,
): DeadLinkPartnerRecovery | undefined {
  if (!details || typeof details !== "object") return undefined;
  const partner = (details as { partner?: unknown }).partner;
  if (!partner || typeof partner !== "object") return undefined;
  const raw = partner as Record<string, unknown>;
  const recovery: DeadLinkPartnerRecovery = {};
  if (typeof raw.name === "string") recovery.name = raw.name;
  if (typeof raw.sessionExpiredRedirectUrl === "string") {
    recovery.sessionExpiredRedirectUrl = raw.sessionExpiredRedirectUrl;
  }
  if (typeof raw.supportEmail === "string") {
    recovery.supportEmail = raw.supportEmail;
  }
  if (typeof raw.supportWhatsappNumber === "string") {
    recovery.supportWhatsappNumber = raw.supportWhatsappNumber;
  }
  return Object.keys(recovery).length > 0 ? recovery : undefined;
}

/** Persist recovery so SessionExpiredPage can offer "return to app". */
export function applyDeadLinkPartnerRecovery(
  partner?: DeadLinkPartnerRecovery | null,
): void {
  if (!partner?.sessionExpiredRedirectUrl && !partner?.name) return;
  usePartnerStore.getState().setPartnerInfo({
    sessionExpiredRedirectUrl: partner.sessionExpiredRedirectUrl,
    name: partner.name,
  });
}
